module.exports = __webpack_public_path__ + "img/feedback8-2.d9d947ac.jpg";